import { FLOATING_CHROME_GAP, supportButtonFootprintAtom } from "@/atoms/bottom-chrome";
import { Button } from "@/components/ui/Button";
import { FloatingAction } from "@/components/ui/FloatingAction";
import { Icon } from "@/components/ui/Icon";
import { CornersIn, CornersOut } from "@/icons";
import { useFullscreen } from "@/lib";
import { useAtomValue } from "jotai";

interface FloatingFullscreenButtonProps {
  className?: string;
}

/**
 * Enter and exit fullscreen from the RIGHT corner of the storefront column.
 * Sits above the support button when that one shares the right side.
 */
export function FloatingFullscreenButton({
  className,
}: FloatingFullscreenButtonProps) {
  const { isFullscreen, toggleFullscreen, isSupported } = useFullscreen();
  const supportButton = useAtomValue(supportButtonFootprintAtom);

  if (!isSupported) {
    return null;
  }

  const supportOffset =
    supportButton?.side === "right"
      ? supportButton.height + FLOATING_CHROME_GAP
      : 0;

  return (
    <FloatingAction side="right" offset={supportOffset}>
      <Button
        variant="outline"
        tone="neutral"
        size="icon-lg"
        shape="circle"
        elevation="raised"
        onClick={toggleFullscreen}
        className={className}
        aria-label={
          isFullscreen
            ? "Sair do modo tela cheia"
            : "Entrar em modo tela cheia"
        }
      >
        <Icon as={isFullscreen ? CornersIn : CornersOut} size="lg" tone="primary" weight="bold" />
      </Button>
    </FloatingAction>
  );
}
